import classNames from 'classnames';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { INearbyResortWDistance } from 'api/region/types';
import TitleCell from 'components/common/Grid/Cells/TitleCell';
import SnowfallCell from 'components/common/Grid/Cells/SnowfallCell';
import BaseDepthCell from 'components/common/Grid/Cells/BaseDepthCell';
import OpenTrailsCell from 'components/common/Grid/Cells/OpenTrailsCell';
import { OpenStatus } from 'components/blocks/OpenStatus';
import { Routes } from 'routes';
import DistanceUnitCell from 'components/common/Grid/Cells/DistanceCell';
import cellStyles from 'components/region/WeatherReports/styles.module.scss';
import gridHeaderStyles from 'components/common/Grid/styles.module.scss';

import { OpenFlag } from 'api/resort/types';
import styles from './styles.module.scss';

export const nearbyResortsGridColumns = () => {
  const { t } = useOTSTranslation('common');

  const columns = [{
    header: {
      columnName: t('region.liftTickets.resort'),
      className: classNames(styles.columnCellHeader, gridHeaderStyles.firstColumn),
      isSortable: true,
    },
    dataKey: 'title',
    cellRender: (resort: INearbyResortWDistance) => (
      <TitleCell
        title={resort.title}
        href={Routes.resortSnowReport({ ...resort, region: resort.region.slug })}
        className={classNames(styles.titleColumnCell)}
      >
        <OpenStatus flag={resort?.status?.openFlag} />
      </TitleCell>
    ),
  },
  {
    header: {
      columnName: t('nearbyResorts.distance'),
      className: styles.columnCellHeader,
      isSortable: true,
    },
    dataKey: 'distance',
    cellRender: ({ distance }: INearbyResortWDistance) => (
      <DistanceUnitCell
        type="kmOrMile"
        values={[distance]}
        noValue="common.dash"
      />
    ),
  },
  {
    header: {
      columnName: t('region.skiReport.snowfall-24h'),
      className: cellStyles.togglingCellTitle,
      isSortable: true,
      cellRender: () => (
        <span>
          <span>{t('region.skiReport.snowfall-24h')}</span>
          <span>{t('region.skiReport.snowfall-24h-abb')}</span>
        </span>
      ),
    },
    dataKey: 'last-snow',
    cellRender: (resort: INearbyResortWDistance) => (
      <SnowfallCell
        openFlag={OpenFlag.Open} // Intentional. Forces render always
        currentWeather={resort.snow}
        noValue={t('common.dash')}
      />
    ),
  },
  {
    header: {
      columnName: t('region.skiReport.baseDepth'),
      className: cellStyles.togglingCellTitle,
      isSortable: true,
      cellRender: () => (
        <span>
          <span>{t('region.skiReport.baseDepth')}</span>
          <span>{t('region.skiReport.base-abb')}</span>
        </span>
      ),
    },
    dataKey: 'snow-base',
    cellRender: (row: INearbyResortWDistance) => (
      <BaseDepthCell
        openFlag={row.status.openFlag}
        snow={row.snow}
        surfaceType={row.surfaceType}
        noValue={t('common.dash')}
      />
    ),
  },
  {
    header: {
      columnName: t('region.skiReport.openTrails'),
      className: cellStyles.togglingCellTitle,
      isSortable: true,
      cellRender: () => (
        <span>
          <span>{t('region.skiReport.openTrails')}</span>
          <span>{t('region.skiReport.trails-abb')}</span>
        </span>
      ),
    },
    dataKey: 'runs-open',
    cellRender: (row: INearbyResortWDistance) => (
      <OpenTrailsCell
        openFlag={row.status.openFlag}
        kilometres={row.km}
        runs={row.runs}
        noValue={t('common.dash')}
      />
    ),
  }];

  return columns;
};
